// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1347":"7ec38517","5303":"5ab76dab","6015":"70950ac1","6830":"ef923f8e"}[chunkId] + ".chunk.css";
};